// extracted by mini-css-extract-plugin
export default {"publicFooter":"publicFooter_publicFooter__6ibUj","copyright":"publicFooter_copyright__qhenz"};